import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Select, Tabs, Alert, DatePicker, Col, Row, Tooltip } from 'antd';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import '../css/form.css';
import EditableTable from '../components/EditableTable';
import { entriesColumns } from '../utils/tableMockData';
import { MdPublish } from "react-icons/md";
import { BiReset } from "react-icons/bi";
import { FaCloudArrowUp } from "react-icons/fa6";
import EventEmitter from '../utils/eventEmitter';
import dayjs from 'dayjs';
import { Badge } from 'flowbite-react';
import useCreditNotesAPI from '../apis/creditNotesAPI';
import EntryTable from '../components/EntryTable';
import InvoiceTable from '../components/InvoiceTable';
// import customParseFormat from 'dayjs/plugin/customParseFormat';
// dayjs.extend(customParseFormat);

export const invoiceColumns = [
  {
    title: 'Product',
    dataIndex: 'product_id',
    key: 'product_id',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '20%'
  },
  {
    title: 'Label',
    dataIndex: 'label',
    key: 'label',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '20%'
  },
  {
    title: 'Account',
    dataIndex: 'account_id',
    key: 'account',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '20%'
  },
  {
    title: 'Analytics',
    dataIndex: 'analytics',
    key: 'analytics',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '15%'
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '5%'
  },
  {
    title: 'Price',
    dataIndex: 'price',
    key: 'price',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '5%'
  },
  {
    title: 'Taxes',
    dataIndex: 'taxes',
    key: 'taxes',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '15%'
  },
  {
    title: 'Subtotal',
    dataIndex: 'subtotal',
    key: 'subtotal',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    width: '10%'
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
  },
];

const InvoiceCreditNotesChanges = () => {
  const { journals, accounts, taxes, entry, analytics, invoice, contacts } = useLoaderData();
  invoice['invoice_date'] = invoice.invoice_date ? dayjs(invoice['invoice_date'], 'YYYY-MM-DD') : '';
  invoice['due_date'] = invoice.due_date ? dayjs(invoice['due_date'], 'YYYY-MM-DD') : '';

  const [invoiceLines, setInvoiceLines] = useState(invoice.line_items ? invoice.line_items : []);
  const [journalEntries, setJournalEntries] = useState(entry.transactions ? entry.transactions : []);
  const [formValue, setFormValue] = useState(invoice.status ? {status: invoice.status} :{status: 'null'});
  const [form] = Form.useForm();
  const [tax, setTax] = useState([]);
  const { success, error } = useOutletContext();
  const [editingKey, setEditingKey] = useState('');
  const params = useParams();
  const [alert, setAlert] = useState({message: '', status: ''});
  const navigate = useNavigate();
  const { save, postCreditNote } = useCreditNotesAPI();
  const [journalDefaultAccount, setJournalDefaultAccount] = useState({});

  const onChangeJournal = opt => {
    setJournalDefaultAccount(opt);
  }

  const handleCreate = () => {
    let data = {...form.getFieldsValue()};
    data['invoice_date'] = new Date(dayjs(data.invoice_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['due_date'] = new Date(dayjs(data.due_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['line_items'] = invoiceLines;
    let journal_id = journals.find(journal => journal.code === data.journal_id)._id;
    const journalEntry = {
      reference: data.reference,
      accounting_date: data.invoice_date,
      journal_code: data.journal_id,
      // journal_id: journal_id,
      transactions: [...journalEntries],
    };
    
    // console.log(data)
    // console.log(journalEntry);
    save({invoice: data, entry: journalEntry}, success);
  }
  
  const handleConfirm = () => {
    let data = {...form.getFieldsValue()};
    data['invoice_date'] = new Date(dayjs(data.invoice_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['due_date'] = new Date(dayjs(data.due_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['line_items'] = invoiceLines;
    data['status'] = 'posted';
    // let journal_id = journals.find(journal => journal.code === data.journal_id)._id;
    const journalEntry = {
      reference: data.reference,
      accounting_date: data.invoice_date,
      journal_code: data.journal_id,
      // journal_id: journal_id,
      status: 'posted',
      transactions: [...journalEntries],
    };
    let analyticItems = [];
    invoiceLines.forEach(entryLine => {
      if (entryLine.analytics) {
        entryLine.analytics.forEach(analyticId => {
          let itemObject = {
            description: data.reference, 
            analytic_account_id: analyticId,
            date: data.invoice_date,
            amount: entryLine.subtotal,
            reference: '',
            quantity: entryLine.quantity,
            product: entryLine.product_id,
            journal_item_number: entry._id,
            account_id: entryLine.account_id
          };
          analyticItems.push(itemObject);
        });
      }
    });
    // console.log(data)
    // console.log(journalEntry);
    postCreditNote(invoice.number.replaceAll('/', '-'), {invoice: data, entry: journalEntry, analyticItems: analyticItems.length>0 ? analyticItems : []}, success);
  }



  useEffect(() => {
    EventEmitter.subscribe('saved_invoice_response', data => {
      navigate('/accounting/invoices/'+data.number.replaceAll('/', '-'));
      setFormValue({...formValue, status: 'draft'});
    });

    EventEmitter.subscribe('invoice_posted', data => {
      navigate('/accounting/invoices/'+data.number);
      setFormValue({...formValue, status: data.status});
    });

    EventEmitter.subscribe('credit_note_posted', data => {
      setFormValue({...formValue, status: 'posted'});
    })

    return () => {
      EventEmitter.unsubscribe('saved_invoice_response');
      EventEmitter.unsubscribe('invoice_posted');
      EventEmitter.unsubscribe('credit_note_posted');
    }
  }, [])


  return (
    <div className='container mx-auto' style={{ maxWidth: '1200px' }}>
      {alert.message !== '' && (
        <Alert message={alert.message} type={alert.status} closable showIcon />
      )}
      <div className='flex justify-between mb-3'>
        <div className='flex '>
          <h3 className='font-bold'>
            <Link to={'/accounting/credit-notes'} className='whitespace-nowrap hover:underline font-medium text-sky-600 dark:text-white'>Credit Notes</Link> / {params.action} 
            {invoice.reference && <span className='text-slate-400'>{` (${invoice.reference})`}</span>}
          </h3>
          <Tooltip
            title='save manually'
            placement='rightBottom'
            className='ms-1'
          >
            <Button onClick={handleCreate} type='text' htmlType='button'
              disabled={formValue.status === 'posted' || formValue.status === 'draft' ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
        </div>

        {/* <div class="arrow-block">
          <div class="arrow"></div>
          <div class="content">
            Your content goes here
          </div>
        </div> */}
        {/* <div class="arrow-block posted">
          <div class="arrow"></div>
          <div class="content">
            Posted
          </div>
        </div>

        <div class="arrow-block draft">
          <div class="arrow"></div>
          <div class="content">
            Draft
          </div>
        </div> */}
      </div>
      <div className='flex justify-between align-center'>
        <div>
          {formValue.status === 'draft' && <div>
            <Button htmlType='button' onClick={handleConfirm} >CONFIRM</Button> 
            <Button htmlType='button' className='mx-1'>CANCEL</Button>
          </div>}
          {formValue.status === 'posted' && <div>
            <Button htmlType='button' >SEND & PRINT</Button> 
            <Button htmlType='button' className='mx-1'>REGISTER PAYMENT</Button>
            <Button htmlType='button' className='mx-1'>RESET TO DRAFT</Button>
          </div>}
        </div>
        {formValue.status !== 'null' && (
          <div id='status-container '>
            <ul className='inner-wrapper'>
              <li
                className={
                  formValue.status === 'draft'
                    ? 'draft-disabled first draft draft-status'
                    : 'first draft-status draft-transparent'
                }
              >
                DRAFT
              </li>
              <li
                className={
                  formValue.status === 'posted'
                    ? 'posted posted-status'
                    : 'posted-status posted-transparent'
                }
              >
                POSTED
              </li>
            </ul>
          </div>
        )}
      </div>
      <div className='mt-5 bg-white'>
        <Form 
          form={form}
          className='shadow p-3' 
          initialValues={invoice.status ? invoice : {
            auto_post: false,
            to_check: false
          }}  
          labelAlign='left'
          labelCol={{span: 10}}
          autoComplete="off"
          variant='borderless'
          disabled={(formValue.status === 'posted') ? true : false}
        >
          <Row>
            <Col md={{span: 11}}>
              <Form.Item label='Customer' name="customer" className='font-bold mb-2 ' required >
                <Select options={contacts.map(contact => ({ value: contact._id, label: contact.name}))} className='font-normal'  placeholder='Select name here' />
              </Form.Item>
              <Form.Item label='Delivery Address' name="delivery_address" className='font-bold mb-2 ' required >
                <Input className='border-x-0 border-t-0 input-outline-none font-normal w-full' placeholder='Enter address here'/>
              </Form.Item>
              <Form.Item label='Reference' name="reference" className='font-bold mb-2 ' required >
                <Input className='border-x-0 border-t-0 input-outline-none font-normal w-full' placeholder='Enter address here'/>
              </Form.Item>
            </Col>
            <Col md={{span: 11}}>
              <Form.Item label="Invoice Date" name="invoice_date" className='font-bold mb-2' required >
                <DatePicker className='border-x-0 border-t-0 input-outline-none w-full border-0 font-normal' />
              </Form.Item>
              <Form.Item label='Payment Reference' name="payment_reference" className='font-bold mb-2 ' required >
                <Input className='border-x-0 border-t-0 input-outline-none font-normal w-full' placeholder='Enter description here'/>
              </Form.Item>
              <Form.Item label="Due Date" name="due_date" className='font-bold mb-2' required >
                <DatePicker className='border-x-0 border-t-0 input-outline-none w-full border-0 font-normal' />
              </Form.Item>
              <Form.Item label='Journal' name={'journal_id'} className='font-bold mb-2' required >
                <Select options={journals.map(journal => ({value: journal._id, label: journal.name, account: journal.default_account}))} onChange={(_, opt)=>onChangeJournal(opt)}  placeholder='select journal' />
              </Form.Item>
            </Col>
          </Row>
          <Tabs
            type='card'
            items={[
              {
                key: '1',
                label: 'Invoice Lines',
                children: <InvoiceTable name={'invoice'} refund={true} dataSource={invoiceLines} invoiceNumber={form.getFieldValue('payment_reference')} setInvoiceLines={setInvoiceLines} entries={journalEntries} setJournalEntries={setJournalEntries} default_account={journalDefaultAccount} columns={invoiceColumns} accounts={accounts} taxes={taxes} analytics={analytics} setTax={setTax} tax={tax} products={[]} status={formValue.status}/>
              },
              {
                key: '2',
                label: 'Journal Items',
                children: <EntryTable dataSource={journalEntries} setJournalEntries={setJournalEntries} columns={entriesColumns} accounts={accounts} analytics={analytics} taxes={taxes} setTax={setTax} tax={tax} status={formValue.status}/>
              },
              {
                key: '3',
                label: 'Other Info',
                active: true,
                children: 
                  <Form 
                    form={form}
                    initialValues={invoice.status ? {auto_post: invoice.auto_post, to_check: invoice.to_check} : {
                      auto_post: false,
                      to_check: false
                    }}  
                    labelAlign='left'
                    labelCol={{span: 10}}
                    autoComplete="off"
                    variant='borderless'
                   
                  >
                  <Row>
                    <Col md={{span: 11}}>
                      <Badge className="text-slate-500 text-md bg-transparent	">INVOICE</Badge>
                      <Form.Item labelCol={{span: 5}} label='Salesperson' name={'salesperson'} className='font-bold ms-2'>
                        <Select options={[]} style={{width: '200px'}}/>
                      </Form.Item>
                    </Col>
                    <Col  md={{span: 10}}>
                      <Badge className="text-slate-500 text-md bg-transparent	">ACCOUNTING</Badge>
                      <Form.Item labelCol={{span: 7}} label='Auto-post' name={'auto_post'} valuePropName='checked' className='font-bold ms-2'>
                        <Checkbox />
                      </Form.Item>
                      <Form.Item labelCol={{span: 7}} label='To Check' name={'to_check'} valuePropName='checked' className='font-bold ms-2'>
                        <Checkbox />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              }
            ]}
          />
        </Form>
      </div>
    </div>
  )
}
export default InvoiceCreditNotesChanges;
